import { getMonthName } from '../../utils';

interface ControlsProps {
    month: number;
    prevMonth: () => void;
    nextMonth: () => void;
}

export const Controls = ({ month, nextMonth, prevMonth }: ControlsProps) => {
    return (
        <div className='controls mt-2'>
            <div
                className='controls__wrapper d-flex justify-content-between align-items-center border rounded '
                style={{
                    background: '#fff',
                    boxShadow: '0.5px 0px 8px 2px #2125290a',
                }}
            >
                <i
                    className='controls__left  ri-arrow-left-s-line fs-5 border rounded p-2 '
                    style={{ cursor: 'pointer' }}
                    onClick={() => nextMonth()}
                ></i>
                <h5 className='controls__title m-0 text-primary2'>
                    {getMonthName(month)}
                </h5>
                <i
                    className='controls__right ri-arrow-right-s-line fs-5 border rounded p-2 '
                    style={{ cursor: 'pointer' }}
                    onClick={() => prevMonth()}
                ></i>
            </div>
        </div>
    );
};
